import axios from 'axios';

export default axios.create({
    baseURL: "http://177.93.108.106:3334"
});